import React, {useEffect} from 'react'
import {Link, withRouter} from 'react-router-dom'
import {withTranslation} from 'react-i18next'
import {Drawer, Row, Col} from 'antd'

import {BinIcon, TrolleyIcon} from 'components/CustomIcons'
import useCartContext from 'components/Cart/useCartContext'
import BButton from 'components/Form/Fields/BButton'
import priceParser from 'utils/priceParser'
import productDetailLink from 'utils/productDetailLink'
import Counter from 'components/Cart/Counter'

const tmpPrice = 4242.42

const DrawerItem = ({item, product, t}) => {
  const {cartDispatch} = useCartContext()

  const cartQuantity = a => {
    cartDispatch({type: 'quantity', payload: {uuid: product.uuid, quantity: a}})
  }

  const cartRemove = event => {
    event.preventDefault()
    cartDispatch({type: 'remove', payload: item.uuid})
  }

  return (
    <div className='cartDrawer-item'>
      <div style={{backgroundImage: `url('${product.main_image_url}')`}}/>
      <div>
        <div className='cartDrawer-itemTitle'>
          <div>
            <p>
              <Link to={() => productDetailLink(product, item.itemIdType)}>{product.name}</Link>
            </p>
            <i>{t('Shop from')} <b>{product.merchant.name}</b></i>
          </div>
          <div>
            <button onClick={cartRemove}><BinIcon/></button>
          </div>
        </div>
        <div className='cartDrawer-priceHandling'>
          <div>
            <Counter amount={item.quantity} setAmount={cartQuantity}/>
          </div>
          <b>{priceParser(item.price)}</b>
        </div>
      </div>
    </div>
  )
}

const DrawerItemsCategory = ({cart, catTitle, t}) => (
  <div className='cartDrawer-category'>
    {/*
    <div className='cartDrawer-categoryTitle'>
      <h6>{catTitle}</h6>
    </div>
    */}

    <div>
      {Object.keys(cart.items).map(key => (
        <DrawerItem key={key} item={cart.items[key]} product={cart.items[key].metaProduct.product} t={t}/>
      ))}
    </div>
  </div>
)

const DrawerItems = ({cart, t}) => {
  return (
    Object.keys(cart.items).length > 0 ? (
      <DrawerItemsCategory cart={cart} catTitle='BUILDING MATERIAL' t={t}/>
    ) : (
      t('Cart is empty')
    )
  )
}


const CartDrawer = ({history, t}) => {
  const {cart, cartVisible, setCartVisible} = useCartContext()

  useEffect(() => {
    history.listen(() => setCartVisible(false))
  }, [history, setCartVisible])

  return (
    <Drawer
      className='cartDrawer'
      onClose={() => setCartVisible(false)}
      visible={cartVisible}
      width={400}
      title={<div><TrolleyIcon/> {t('Your basket')}</div>}
      footer={
        <div className='cartDrawer-footer'>
          <Row>
            <Col span={12}>
              <b>{t('Order total')}</b>
            </Col>
            <Col span={12}>
              <b>{priceParser(tmpPrice)}</b>
              <span>{t('Inc. VAT')}</span>
            </Col>
          </Row>
          <Link to='/checkout'><BButton yellow>{t('CONTINUE TO CHECKOUT')}</BButton></Link>
        </div>
      }
    >
      <DrawerItems cart={cart} t={t}/>
    </Drawer>
  )
}

export default withRouter(withTranslation()(CartDrawer))
